/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type ProfileIcon_tradeFirm = {
    readonly serviceId: string | null;
    readonly name: string | null;
    readonly publicProfile: {
        readonly profilePhoto: string | null;
        readonly splashPhotoId: string | null;
    } | null;
    readonly " $refType": "ProfileIcon_tradeFirm";
};
export type ProfileIcon_tradeFirm$data = ProfileIcon_tradeFirm;
export type ProfileIcon_tradeFirm$key = {
    readonly " $data"?: ProfileIcon_tradeFirm$data;
    readonly " $fragmentRefs": FragmentRefs<"ProfileIcon_tradeFirm">;
};



const node: ReaderFragment = {
  "kind": "Fragment",
  "name": "ProfileIcon_tradeFirm",
  "type": "TradeFirmType",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "serviceId",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "name",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "publicProfile",
      "storageKey": null,
      "args": null,
      "concreteType": "TradeFirmPublicProfileType",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "profilePhoto",
          "args": null,
          "storageKey": null
        },
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "splashPhotoId",
          "args": null,
          "storageKey": null
        }
      ]
    }
  ]
};
(node as any).hash = 'c6192c4ab979e1885f3df7961c85bc48';
export default node;
